module.exports = __webpack_public_path__ + "static/media/light4.105fbdee.png";